import { MouseEvent, useCallback } from 'react';
import styled from 'styled-components';
import { useRfqBuilderModalMethods } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/modal-context';
import {
  paradigmLightBlue,
  strongBlue,
} from '@paradigm/design-system/src/colors';
import { useUMPlatformCreationDisabled } from '@paradigm/features/src/platform-state/contexts/providers';
import { useTrackAction } from '@paradigm/features/src/analytics';

export const MobileOpenRfqBuilderButton = () => {
  const { open } = useRfqBuilderModalMethods();
  const isPlatformCreationDisabled = useUMPlatformCreationDisabled();
  const trackAction = useTrackAction();
  const onClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      trackAction('create market');
      e.preventDefault();
      e.stopPropagation();
      if (!isPlatformCreationDisabled) open();
    },
    [isPlatformCreationDisabled, open, trackAction],
  );
  return <Container disabled={isPlatformCreationDisabled} onClick={onClick} />;
};

const Container = styled.button`
  position: absolute;
  bottom: 12px;
  right: 16px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
  border-radius: 40px;
  border: none;
  cursor: pointer;
  background: radial-gradient(
    circle,
    ${paradigmLightBlue} 0%,
    ${strongBlue} 100%
  );
  box-shadow: 0 0 20px 0 rgba(14, 105, 238, 0.5);

  ::after {
    content: ' ';
    position: absolute;
    display: block;
    background-color: #ffffff;
    height: 2px;
    border-radius: 2px;
    top: calc(50% - 1px);
    left: 25%;
    right: 25%;
  }

  ::before {
    content: ' ';
    position: absolute;
    display: block;
    background-color: #ffffff;
    width: 2px;
    border-radius: 2px;
    left: calc(50% - 1px);
    top: 25%;
    bottom: 25%;
  }
  :disabled {
    opacity: 0.7;
    cursor: initial;
  }
`;
